import { FooterMobile } from "../Layout/FooterMobile";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import HeroBanner from '../components/HeroBanner';
import Breadcrumbs from "../components/Breadcrumb";
import VidyardPlayer from "../components/VidyardPlayer";
import imgLccbanner from "../assets/images/banners/lcc-banner.png";
import iconJoinLC1 from "../assets/images/siteImg/checklistImg/Icon_JoinLC_1.svg";
import iconJoinLC2 from "../assets/images/siteImg/checklistImg/Icon_JoinLC_2.svg";
import iconJoinLC3 from "../assets/images/siteImg/checklistImg/Icon_JoinLC_3.svg";
import imgLcc from "../assets/images/lcc.jpg";
import ButtonLink from "../components/ButtonLink";
export function LearningCoachCommunity() {
    const breadcrumbItems = [
        { label: "Home", path: "/" },
        { label: "Community", path: "/community" },
        { label: "Learning Coach Community" }, 
    ];
    return (
        <>
            
            <div className="home-layout">
                <div className="sidebar-wrapper">
                <Sidebar />
                </div>
                <div className="body-wrapper-content">
                <div className="row">
                    <div className="col-12">
                    <Header />
                    <main id="main" role="main">
                        <div className="main-content">
                            <div className="row">
                                <div className="col-12">
                                    <Breadcrumbs items={breadcrumbItems} />                          
                                </div>
                            </div>

                            <HeroBanner
                                title="Learning Coach Community"
                                subtitle="Welcome! When you join the Learning Coach (LC) Community, you become a valued member of a secure, caring network where you can meet virtually or in person to share advice and support. "
                                imageUrl={imgLccbanner}
                                altText="Learning Coach Community"
                                customClass="bg-color-blue-t1-community common-banner-bg-white"
                            />

                            <div className="wp-block-k12-section container-fluid bg-transparent">
                            <div className="row">
                                <div className="col-12 g-0">
                                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-4 align-items-start wp-block-columns-is-layout-flex">
                                    <div className="wp-block-column lc-community-block is-layout-flow wp-block-column-is-layout-flow">
                                    <figure className="wp-block-image size-full px-2">
                                        <img
                                            decoding="async"
                                            width="2190"
                                            height="1369"
                                            src={imgLcc}
                                            alt="map image"
                                            className="wp-image-83228"
                                            sizes="(max-width: 2190px) 100vw, 2190px"
                                        />
                                    </figure>

                                    <div className="wp-block-k12-section container-fluid bg-transparent">
                                        <div className="row">
                                        <div className="col-12 g-0">
                                            <div className="wp-block-k12-landing-community btn-primary m-0 lc-btn">
                                            <div className="row g-0 map-top">
                                                <div className="community-map-wrapper bg-color-white">
                                                <div className="col-md-12 col-xxl-12">
                                                    <div className="body">
                                                    <h3>
                                                        <strong>Connect</strong> Locally
                                                    </h3>
                                                    <p>
                                                    Join your school’s LC Community to find families in your area! <br /><br />
                                                    
                                                    <ButtonLink
                                                    urlKey="COMMUNITY_URL"
                                                    label="Find your Community"
                                                    className="external-link-btn"
                                                    source="links"
                                                    target="_blank"
                                                    />
                                                    </p>

                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>

                                    {/* Right Column */}
                                    <div
                                    className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                                    style={{ flexBasis: "33.33%" }}
                                    >
                                    <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-2rem">
                                        <div className="row">
                                        <div className="col-12">
                                            <h3 className="wp-block-heading m-0">Join the K12 LC Community</h3>

                                            <div className="video-block mb-3">
                                                <div className="row">
                                                    <div style={{ display: "block", opacity: 1 }}>
                                                        <VidyardPlayer uuid="stCmdSkoEE8rG8JBNptpPZ" type="lightbox" />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Block 1 */}
                                            <div className="wp-block-columns gap-3 is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex align-items-start">
                                            <div
                                                className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                                                style={{ flexBasis: "24px" }}
                                            >
                                                <figure className="wp-block-image size-large is-resized">
                                                <img
                                                    decoding="async"
                                                    width="24"
                                                    height="24"
                                                    src={iconJoinLC1}
                                                    alt=""
                                                    className="wp-image-451"
                                                    style={{ width: "24px" }}
                                                />
                                                </figure>
                                            </div>
                                            <div className="wp-block-column mb-3 is-layout-flow wp-block-column-is-layout-flow">
                                                <h4 className="wp-block-heading mb-1">Meet Your Fellow Learning Coaches&nbsp;</h4>
                                                <p>
                                                Connect with other parents who’ve been in your shoes and know their K12-powered
                                                school inside and out.&nbsp;
                                                </p>
                                            </div>
                                            </div>

                                            {/* Block 2 */}
                                            <div className="wp-block-columns gap-3 is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex align-items-start">
                                            <div
                                                className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                                                style={{ flexBasis: "24px" }}
                                            >
                                                <figure className="wp-block-image size-large is-resized">
                                                <img
                                                    decoding="async"
                                                    width="24"
                                                    height="24"
                                                    src={iconJoinLC2}
                                                    alt=""
                                                    className="wp-image-452"
                                                    style={{ width: "24px" }}
                                                />
                                                </figure>
                                            </div>
                                            <div className="wp-block-column mb-3 is-layout-flow wp-block-column-is-layout-flow">
                                                <h4 className="wp-block-heading mb-1">Gain Insights</h4>
                                                <p>Ask questions, exchange resources, and learn from experienced Learning Coaches.&nbsp;</p>
                                            </div>
                                            </div>

                                            {/* Block 3 */}
                                            <div className="wp-block-columns gap-3 is-layout-flex wp-container-core-columns-is-layout-3 wp-block-columns-is-layout-flex align-items-start">
                                            <div
                                                className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                                                style={{ flexBasis: "24px" }}
                                            >
                                                <figure className="wp-block-image size-large is-resized">
                                                <img
                                                    decoding="async"
                                                    width="24"
                                                    height="24"
                                                    src={iconJoinLC3}
                                                    alt=""
                                                    className="wp-image-453"
                                                    style={{ width: "24px" }}
                                                />
                                                </figure>
                                            </div>
                                            <div className="wp-block-column mb-3 is-layout-flow wp-block-column-is-layout-flow">
                                                <h4 className="wp-block-heading mb-1">Build Connections&nbsp;</h4>
                                                <p>
                                                Navigate the world of online education together, sharing in each other’s successes.&nbsp;
                                                </p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div> {/* Closing Right Column */}
                                </div>
                                </div>
                            </div>
                            </div>


                        </div>
                    </main>
                    </div>
                </div>

                </div>
                <FooterMobile />
            </div>
        </>   
    );
}